<template>
  <div class="stars-wrap">
    <div class="stars-layer stars-small"></div>
    <div class="stars-layer stars-medium"></div>
    <div class="stars-layer stars-big"></div>
  </div>
</template>

<style>
.stars-wrap {
  position: fixed;
  inset: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}
.stars-layer {
  position: absolute;
  top: 0;
  left: 0;
  width: 1px;
  height: 1px;
  background: transparent;
}
.stars-layer::after {
  content: '';
  position: absolute;
  top: 2000px;
  left: 0;
  width: inherit;
  height: inherit;
  background: inherit;
  box-shadow: inherit;
}
.stars-small {
  box-shadow:
    1309px 228px #FFF, 51px 1518px #FFF, 563px 501px #FFF, 457px 285px #FFF,
    1508px 209px #FFF, 1385px 1516px #FFF, 1827px 1116px #FFF, 178px 1209px #FFF,
    864px 65px #FFF, 61px 191px #FFF, 447px 476px #FFF, 1034px 1232px #FFF,
    54px 1149px #FFF, 407px 1466px #FFF, 1330px 1436px #FFF, 1116px 859px #FFF,
    451px 919px #FFF, 1206px 569px #FFF, 1657px 1780px #FFF, 13px 1554px #FFF,
    1650px 326px #FFF, 1429px 865px #FFF, 696px 569px #FFF, 318px 440px #FFF,
    1960px 1563px #FFF, 689px 209px #FFF, 189px 778px #FFF, 198px 735px #FFF,
    1735px 704px #FFF, 1236px 541px #FFF, 1652px 88px #FFF, 1494px 940px #FFF,
    1098px 255px #FFF, 1992px 1888px #FFF, 775px 161px #FFF, 1130px 600px #FFF,
    1698px 1287px #FFF, 1266px 1813px #FFF, 1764px 740px #FFF, 1182px 393px #FFF,
    1442px 142px #FFF, 93px 1354px #FFF, 466px 1583px #FFF, 592px 163px #FFF,
    1751px 476px #FFF, 1774px 206px #FFF, 778px 569px #FFF, 928px 1301px #FFF,
    1708px 747px #FFF, 333px 758px #FFF, 727px 429px #FFF, 1372px 546px #FFF,
    1437px 1918px #FFF, 1399px 1327px #FFF, 146px 1247px #FFF, 1300px 350px #FFF,
    1093px 1493px #FFF, 501px 334px #FFF, 946px 777px #FFF, 552px 1895px #FFF,
    1310px 1409px #FFF, 1140px 449px #FFF, 1402px 664px #FFF, 1726px 1573px #FFF,
    1589px 114px #FFF, 469px 1683px #FFF, 65px 1648px #FFF, 646px 821px #FFF,
    548px 135px #FFF, 432px 1870px #FFF, 1931px 1161px #FFF, 1794px 1470px #FFF,
    644px 435px #FFF, 1342px 1022px #FFF, 810px 1811px #FFF, 1872px 1316px #FFF,
    939px 292px #FFF, 542px 285px #FFF, 505px 1525px #FFF, 1149px 1103px #FFF,
    538px 1529px #FFF, 1197px 877px #FFF, 1838px 1195px #FFF, 817px 741px #FFF,
    449px 283px #FFF, 1043px 1010px #FFF, 186px 1547px #FFF, 96px 1763px #FFF,
    224px 313px #FFF, 1285px 327px #FFF, 1622px 1393px #FFF, 864px 1221px #FFF,
    130px 788px #FFF, 781px 1220px #FFF, 958px 1083px #FFF, 514px 1988px #FFF,
    1133px 1762px #FFF, 1930px 23px #FFF, 1393px 1476px #FFF, 234px 1396px #FFF,
    1812px 1099px #FFF, 1537px 546px #FFF, 1574px 1312px #FFF, 696px 228px #FFF,
    601px 890px #FFF, 323px 929px #FFF, 6px 1953px #FFF, 1478px 1793px #FFF,
    1473px 539px #FFF, 1990px 1025px #FFF, 1560px 365px #FFF, 1039px 1869px #FFF,
    217px 1782px #FFF, 1280px 611px #FFF, 1723px 1308px #FFF, 1039px 1247px #FFF,
    407px 313px #FFF, 765px 1561px #FFF, 330px 1104px #FFF, 1952px 1594px #FFF,
    1889px 1086px #FFF, 1881px 1px #FFF, 1226px 663px #FFF, 1000px 39px #FFF,
    229px 1902px #FFF, 743px 1799px #FFF, 1703px 1652px #FFF, 629px 490px #FFF,
    118px 493px #FFF, 1798px 1161px #FFF, 1939px 161px #FFF, 175px 1498px #FFF,
    995px 1671px #FFF, 141px 1557px #FFF, 1090px 1568px #FFF, 257px 262px #FFF,
    1351px 973px #FFF, 1939px 1125px #FFF, 338px 542px #FFF, 1080px 1786px #FFF,
    1242px 866px #FFF, 1975px 433px #FFF, 1902px 1104px #FFF, 1546px 1494px #FFF,
    1412px 411px #FFF, 1460px 638px #FFF, 817px 1375px #FFF, 1330px 764px #FFF,
    897px 1842px #FFF, 1059px 924px #FFF, 247px 507px #FFF, 460px 131px #FFF,
    692px 43px #FFF, 1204px 1134px #FFF, 471px 1205px #FFF, 451px 14px #FFF;
  animation: drift 120s linear infinite;
}
.stars-medium {
  width: 2px;
  height: 2px;
  box-shadow:
    896px 164px #FFF, 1224px 81px #FFF, 1821px 884px #FFF, 1504px 660px #FFF,
    1236px 512px #FFF, 52px 187px #FFF, 468px 1969px #FFF, 1380px 1712px #FFF,
    1762px 1178px #FFF, 1202px 1947px #FFF, 42px 1566px #FFF, 1376px 1682px #FFF,
    551px 1180px #FFF, 82px 1562px #FFF, 1548px 358px #FFF, 963px 1062px #FFF,
    1334px 905px #FFF, 1876px 569px #FFF, 371px 1198px #FFF, 892px 1300px #FFF,
    1667px 1007px #FFF, 1984px 186px #FFF, 962px 712px #FFF, 836px 682px #FFF,
    657px 1372px #FFF, 214px 1756px #FFF, 329px 675px #FFF, 843px 1420px #FFF,
    1014px 590px #FFF, 1356px 1935px #FFF, 820px 1666px #FFF, 1557px 1126px #FFF,
    75px 931px #FFF, 180px 644px #FFF, 516px 662px #FFF, 237px 1986px #FFF,
    1582px 827px #FFF, 1771px 1053px #FFF, 1689px 2px #FFF, 1346px 1780px #FFF,
    1111px 946px #FFF, 846px 111px #FFF, 384px 1061px #FFF, 740px 1275px #FFF,
    1549px 1020px #FFF, 1280px 905px #FFF, 1556px 105px #FFF, 416px 546px #FFF,
    1124px 268px #FFF, 1899px 589px #FFF, 897px 1803px #FFF, 1430px 992px #FFF,
    248px 59px #FFF, 1993px 1290px #FFF, 1246px 1636px #FFF, 490px 1453px #FFF,
    324px 636px #FFF, 1128px 28px #FFF, 1131px 835px #FFF, 190px 460px #FFF,
    1723px 1869px #FFF, 232px 945px #FFF, 1939px 240px #FFF, 1326px 1704px #FFF,
    315px 1020px #FFF, 1910px 1467px #FFF, 597px 1042px #FFF, 1444px 559px #FFF,
    850px 1709px #FFF, 988px 967px #FFF, 499px 935px #FFF, 1128px 296px #FFF,
    785px 390px #FFF, 1887px 1227px #FFF, 1040px 1528px #FFF, 1800px 279px #FFF,
    1769px 142px #FFF, 565px 1582px #FFF, 1617px 1749px #FFF, 849px 696px #FFF,
    1913px 1613px #FFF, 1039px 547px #FFF, 1680px 5px #FFF, 579px 1486px #FFF;
  animation: drift 200s linear infinite;
}
.stars-big {
  width: 3px;
  height: 3px;
  box-shadow:
    1286px 198px #FFF, 1850px 1285px #FFF, 1323px 80px #FFF, 632px 1615px #FFF,
    902px 68px #FFF, 1186px 747px #FFF, 1499px 269px #FFF, 184px 1862px #FFF,
    604px 669px #FFF, 1530px 850px #FFF, 359px 411px #FFF, 270px 1610px #FFF,
    1104px 1794px #FFF, 1989px 749px #FFF, 1087px 1027px #FFF, 1870px 558px #FFF,
    1700px 336px #FFF, 526px 1871px #FFF, 1688px 1933px #FFF, 986px 1981px #FFF,
    1651px 604px #FFF, 1528px 1782px #FFF, 693px 1647px #FFF, 235px 959px #FFF,
    1972px 154px #FFF, 288px 1544px #FFF, 1979px 462px #FFF, 1761px 1385px #FFF,
    1483px 1381px #FFF, 813px 1980px #FFF, 1732px 1647px #FFF, 1141px 749px #FFF,
    184px 1619px #FFF, 808px 28px #FFF, 541px 1098px #FFF, 253px 931px #FFF,
    754px 1377px #FFF, 1533px 1376px #FFF, 536px 1197px #FFF, 780px 1684px #FFF,
    1307px 1925px #FFF, 760px 221px #FFF, 1382px 478px #FFF, 965px 51px #FFF,
    1268px 1810px #FFF, 1931px 1149px #FFF, 671px 1874px #FFF, 1249px 453px #FFF,
    1326px 129px #FFF, 1301px 1687px #FFF;
  animation: drift 300s linear infinite;
}
@keyframes drift {
  from { transform: translateY(0); }
  to   { transform: translateY(-2000px); }
}
@media (prefers-reduced-motion: reduce) {
  .stars-small, .stars-medium, .stars-big { animation: none; }
}
</style>
